import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { flowDigitalClockItemStyle } from './digitalclock.theme';

export const flowMultiSectionDigitalClock: Components<Theme>['MuiMultiSectionDigitalClock'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      // sections
      '& .MuiMultiSectionDigitalClockSection-root': {
        // prevent jump on hover due to scrollbar appearing
        scrollbarGutter: 'stable',
      },
      // item
      '& .MuiMultiSectionDigitalClockSection-item': {
        ...flowDigitalClockItemStyle(theme),
      },
    }),
  },
};
